<template>
  <PageLayout :title="$t('profile.billing_title')">
    <ProfileBilling />
  </PageLayout>
</template>

<script>
import ProfileBilling from '@/components/billing/ProfileBilling.vue'

export default {
  components: { ProfileBilling },
}
</script>
